module.exports = __webpack_public_path__ + "img/7C.4808cc41.png";